// NOTE: We used to check productData.variants, but this does not work well for Apartment Student
// where product has two variants, but buyer can only see one at a time. So, checking tiers on actual offers
// is better, even if we depend on having priceIntent ready
import { usePriceIntent } from '../usePriceIntent'

export const useHasOffersFromMultipleTiers = () => {
  const { priceIntent } = usePriceIntent()
  if (!priceIntent) return false
  const termsVersions = new Set(priceIntent.offers.map((offer) => offer.variant.termsVersion))
  return termsVersions.size > 1
}
